import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostFinanceAccountsRequestModel, PostFinanceAccountsResponseModel } from "@/features/accounts/finance/services/post-accounts-model";

export class PostFinanceAccountsApi {
  /**
   * 銀行口座登録API
   */
  public postFinanceAccounts = async (
    param: PostFinanceAccountsRequestModel
  ): Promise<PostFinanceAccountsResponseModel[]> => {
    const path = `/api/financeaccounts/finances`;
    const res = await ApiClient.instance.post<PostFinanceAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
